export default __webpack_public_path__ + "static/media/vikrant.fa069bb9.jpg";